import Actions         from "../../../model/constant/actions"
import ReducerUtils    from "../../../utils/ReducerUtils"

const rememberAccountLoaded = (state,action) => {
  return [...state, action.accountId]
}
export const FetchedAccounts = ReducerUtils.createReducer<number[]>([],{
  [Actions.RETRIEVE_KEYWORD_PATTERNS_FOR_ACCOUNTID] : rememberAccountLoaded,
})
